<template>
  <div class="pagebox" :lang="isArab?'ar' : 'en'" :dir="isArab?'rtl' : 'ltr'">
    <div class="loading" v-if="isloading">
       <img class="loadimg" width="40" height="40" src="./../assets/loading.svg">
    </div>
    <!-- <video
      src="https://cdn.moji.com/websrc/video/spring20200311.mp4"
      class="videobox"
      controls="true"
      preload="auto"
    ></video>-->
    <div class="videobox" lang="en" dir="ltr" v-show="!showHostImg">
      <video ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9 myvideo" ></video>
      <!-- <div class="playBtn" @click="startplay" :class="!isplay?'showBtn':'hideBtn'">
          <div></div>
      </div> -->
      <div class="soundBtn" @click="closeSound">
          <div class="soundIcon closesound" v-if="!isCloseSound"></div>
          <div class="soundIcon opensound" v-if="isCloseSound"></div>
      </div>
    </div>
    <div v-if="showHostImg" class="hostimgbox">
        <img class="hostImg" alt="" :src="hostImg" >
    </div>
    <!-- <div class="menuhead">
        <div class="menuItem" :class="menuNum == 0?'menuItemActive':'menuItemUnactive'" @click="chooseMenu(0)">{{langText["menuText1"]}}</div>
        <div class="borderline"></div>
        <div class="menuItem" :class="menuNum == 1?'menuItemActive':'menuItemUnactive'" @click="chooseMenu(1)">{{langText["menuText2"]}}</div>

    </div> -->
      <Jump2vote :isArab="isArab" :jump2voteProps="jump2voteProps" v-if="jump2voteProps" ></Jump2vote>
    <!-- <IntroComponent v-show="menuNum == 0" :detailData="detailInfo" ref="intro"></IntroComponent> -->
    <IntroComponent  :detailData="detailInfo" ref="intro" @changeHost="changeHostId"></IntroComponent>
    <!-- <ChallengeComponent v-show="menuNum == 1" :detailData="detailInfo"></ChallengeComponent> -->
  </div>
</template>

<script>
import {_di} from './../common/js/di';
import videojs from "video.js";
import "video.js/dist/video-js.css";
import IntroComponent from './../components/KolIntro';
import ChallengeComponent from './../components/KolChallenge';
import Jump2vote from "../components/Jump2vote";
import {lang} from './../language/kol';
export default {
  name: "KolBoardPage",
  data() {
    return {
      isloading: true,
      fromType: 0,
      token: "",
      userId: "",
      host_id: "",
      recommend_id: "",
      langType: "",
      isArab: false,
      langText: {},
      menuNum: 0,
      player: null,
      isplay: true,
      isCloseSound: false,
      isEnterFromLive: false,
      hostImg: "",
      showHostImg: false,
      detailInfo: {
        name: "",
        uid: "",
        avatar: "",
        level: "",
        subscribed: false,
        following: false,
        next_live_time: '',
        can_vote: "",
        menus:[],
        introduction_ar: '',
        introduction: '',
        recommend: [],
      },
      options: {
        autoplay: "autoplay",
        controls: false,
        loop: true,
        muted: true,
        preload: 'auto',
        volume: 0,
        playsinline: true,
        poster: "",
        sources: [
          {
            src: "",
            type: "video/mp4",
          }
        ]
      },
      jump2voteProps:null //新增
    };
  },
  components: {IntroComponent, ChallengeComponent,Jump2vote},
  created() {
     document.title = "KOL Landing page";
  },
  mounted() {
    this.kolurl = process.env.KOLURL;
    this.userId = this.getUrlParam("userId") || 1004343;
    this.host_id = this.getUrlParam("hostId") || 1004448 ; //1002812
    this.recommend_id = this.getUrlParam("hostId") || 1004448 ; //1002812
    this.token = this.getUrlParam("token") || '';
    this.fromType = this.getUrlParam("type") || 0;
    this.langType = this.getUrlParam('lang') === 'ar' ? 'ar' : 'en';
    this.isArab = this.langType == "ar"?true: false;
    this.langText = lang[this.langType];
    this.jump2voteProps={
        userId:this.userId,
        host_id:this.host_id,
        token:this.token,
        fromType:this.fromType,
        isArab:this.isArab
    }

    if(this.fromType == 4 || this.fromType == 2){
       this.menuNum = 1;
    }else{
       this.menuNum = 0;
    }

    console.log(this.menuNum)
    this.initVideoPlayer();
    this.getLandInfo();
    //di打点相关
    this.eventTrack = {
        kol_page: _di('kol.page',42621),
        kol_witch: _di('kol.witch',42622),
        kol_sound:_di('kol.sound')

    }
    //打点
    this.eventTrack.kol_page({
        "user_id": this.userId,
        "host_id": this.host_id,
        "type": this.fromType
    });
  },
  beforeDestroy() {
    if (this.player) {
      this.player.muted(true);
      this.player.dispose();
    }
  },
  methods: {
    initVideoPlayer() {
       this.player = videojs(
        this.$refs.videoPlayer,
        this.options,
        function onPlayerReady() {
            console.log("onPlayerReady", this);
        }
        );
        this.player.volume(0);
    },
    getLandInfo(recommend_id) {
      var url = this.kolurl + "/kol/landing-info";
      var params = {
        host_id: this.host_id,
        uid: this.userId,
        token: this.token,
        recommend: recommend_id?recommend_id:null,
      };
      this.$axios.get(url, { params: params }).then(response => {
        var resData = response.data;
        this.detailInfo = resData;
        // this.options.sources.src = resData.video;
        // this.options.poster = resData.picture;
        // resData.video = null
        if(!!resData.video){
          this.showHostImg = false;
          // this.player.poster(resData.picture);
          this.player.src(resData.video);
          this.player.load();
          // setTimeout(()=> {
          //   this.player.load();
          // },1000)
        }else{
          this.showHostImg = true;
          this.hostImg = resData.picture;
        }
        this.isloading = false;
        
      });
    },
    changeHostId(host_id){
       this.host_id = host_id;
      //  this.$router.push({
      //       path: '/kolboard',
      //       query: {
      //           userId: this.userId,
      //           hostId: this.host_id,
      //           lang: this.langType,
      //           token: this.token
      //       },
      //   });
       this.player.pause();
       
       this.getLandInfo(this.recommend_id);
      //  this.$router.go(1);
    },
    startplay() {
      if(!this.isplay){
        this.player.play();
        this.isplay = true;
      }else{
        this.player.pause();
        this.isplay = false;
      }
     
    },
    closeSound() {
       var volumeNum = this.player.volume();
       var mutedplay = this.player.muted();
       if(mutedplay){
           this.player.muted(false);
           this.player.volume(1);
           this.isCloseSound = true;
       }else{
           this.player.muted(true);
        //    this.player.volume(0);
           this.isCloseSound = false;
       }
       //新增切换声音埋点
        this.eventTrack.kol_sound({
            "user_id": this.userId,
            "host_id": this.host_id,
            "type": this.fromType,
            "isCloseSound":this.isCloseSound,
            "page":"KolBoardPage",
            "title":"KolBoardPage"
        });
    },
    chooseMenu(index) {
       this.menuNum = index;
       //打点
        this.eventTrack.kol_witch({
            "user_id": this.userId,
            "type": index
        });
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pagebox {
  width: 100%;
  position: relative;
}
.loading{
    width: 100vw;
    height:100vh;
    background: #fff;
    position: fixed;
    left: 0;
    top:0;
    z-index: 5;
}
.loadimg{
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -20px;
    margin-left: -20px;
}
.videobox {
  width: 100%;
  position: relative;
  overflow: hidden;
  /* margin-bottom: 0.5rem; */
  /* position: fixed; */
  
}
.hostimgbox{
  width: 100%;
  height: 2.12rem;
  overflow: hidden;
  /* margin-bottom: 0.5rem; */
}
.hostImg {
  width: 100%;
  height: auto;
  /* position: absolute;
  left: 0;
  top: 0;
  z-index: 70; */
}

.playBtn{
  width: 0.46rem;
  height: 0.46rem;
  border-radius: 0.23rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -0.23rem;
  margin-left: -0.23rem;
  z-index: 2;
  background: rgba(255,255,255,0.3);
  
}
.playBtn div{
    width: 0.17rem;
    height: 0.19rem;
    background: url('./../assets/1@2x.png');
    background-size: 100%;
    margin-left: 0.15rem;
    margin-top:0.13rem;
}
.showBtn {
  display: inline-block;
}
.hideBtn {
  opacity: 0; filter:Alpha(opacity=0);
}
.soundBtn{
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  left: 6%;
  bottom: 10%;
  z-index: 2;
  
}
.soundIcon{
  width: 100%;
  height: 100%;
}
.closesound{
   background: url('./../assets/invalidName@2x.png');
   background-size: 100%;
}
.opensound{
   background: url('./../assets/invalid@2x.png');
   background-size: 100%;
}
.menuhead {
    width: 100%;
    height: 0.4rem;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.menuhead:after {
    content: '';
    position: absolute;
    left: 0;
    bottom:0;
    background: rgb(232, 232, 232);
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    z-index: -1;
}
.menuItem {
    width: 1.87rem;
    height: 0.4rem;
    line-height: 0.4rem;
    text-align: center;
    position: relative;
    /* background: yellow; */
}

.menuItemActive {
    font-size: 0.14rem;
    color: rgb(44,44,48);
    font-weight: bolder;
}
.menuItemActive::after {
    content: '';
    position: absolute;
    left: 0.85rem;
    bottom: 0rem;
    width: 0.12rem;
    height: 0.06rem;
    background: url('./../assets/hover@2x.jpg');
    background-size: 100%;
}
.menuItemUnactive {
    font-size: 0.14rem;
    color: rgb(171,173,186);
}
.borderline{
    width: 1px;
    height: 0.3rem;
    position: relative;
}
.borderline:after {
    content: '';
    position: absolute;
    left: 0;
    bottom:0;
    background: rgb(232, 232, 232);
    width: 1px;
    height: 100%;
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    z-index: -1;
}

</style>



// WEBPACK FOOTER //
// src/page/KolBoardPage.vue